export enum Role {
  Patient = 'PATIENT',
  Doctor = 'DOCTOR',
  Administrator = 'ADMIN',
  Buddy = 'BUDDY'
}